import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, isRef as _isRef, mergeProps as _mergeProps, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec20fe5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = {
  key: 0,
  class: "dropdown-btn-active"
}
const _hoisted_3 = {
  key: 1,
  class: "style__avatar"
}
const _hoisted_4 = { class: "!tw-truncate tw-max-w-[95px] !tw-inline-block" }
const _hoisted_5 = {
  key: 0,
  class: "tw-w-[10px] tw-h-[7px]",
  src: "/img/up_arrow_dark.svg",
  alt: "up_arrow"
}
const _hoisted_6 = {
  key: 1,
  class: "tw-w-[10px] tw-h-[7px]",
  src: "/img/down_arrow_dark.svg",
  alt: "down_arrow"
}
const _hoisted_7 = {
  key: 2,
  class: "tw-w-full tw-flex tw-rounded-[6px] tw-bg-[#ffffff] tw-pl-[6px]"
}
const _hoisted_8 = { class: "tw-h-[38px] tw-w-[38px] tw-justify-end" }
const _hoisted_9 = { class: "tw-flex parent__avatar" }
const _hoisted_10 = { class: "tw-text-[13px] tw-leading-5 tw-font-medium !tw-truncate tw-max-w-[130px] !tw-inline-block tw-mx-[10px] tw-items-center" }
const _hoisted_11 = {
  key: 0,
  src: "/img/home_icon.svg",
  alt: "home-icon",
  class: "home-icon"
}
const _hoisted_12 = {
  key: 1,
  id: "search-box-org",
  class: "tw-mx-[15px] tw-mt-2"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 3,
  class: "dropdown__menu__items"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "org_items" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["data-cy"]
const _hoisted_19 = {
  key: 2,
  src: "/img/home_icon.svg",
  alt: "home-icon",
  class: "home-icon"
}
const _hoisted_20 = { class: "org-status" }
const _hoisted_21 = {
  key: 0,
  class: "current-status"
}
const _hoisted_22 = { class: "org__operations" }
const _hoisted_23 = { class: "dropdown__menu__item orgOperation" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/right_arrow_icon.svg",
  alt: "right_arrow"
}, null, -1))
const _hoisted_25 = { class: "dropdown__menu__item orgOperation" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/right_arrow_icon.svg",
  alt: "right_arrow"
}, null, -1))

import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { ref, watch, computed, onMounted, onBeforeUnmount, Ref } from "vue";
import { getComponentUiText, getImageData } from "@/utils/utilities";
import ManageOrgDropDown from "./manageOrgDropDown.vue";
import Modal from "@/components/common/modal.vue";
import { useRoute, useRouter } from "vue-router";
import {
  INDEX_PRIMARY_PAGE,
  localStorageBoolean,
  localStorageKey,
  ModalTypes,
  requestAccessDetailModalType,
} from "@/utils/constants";
import CreateOrgModal from "@/components/orgManagement/createOrgModal.vue";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import { getOrgIdProfile, leaveOrg } from "@/services/org";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import { onUnmounted } from "vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import { getProfileImage } from "@/services/org";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import { debounce } from "lodash";

export type orgItem = {
  id: number;
  name: string;
  icon: string;
  isHome: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'activeOrgDropDown',
  props: {
  statusSetupModal: {
    type: Boolean,
    required: false,
    default: false,
  },
  userData: {
    type: Object,
    required: true,
  },
},
  emits: ["update:show"],
  setup(__props, { emit }) {

const props = __props;



// Define your reactive data and refs
const currentParentOrg = computed(() => store.state.Org.currentParentOrg);
const isOrgSwitchLoading: Ref<boolean> = ref(false);
const isMenuOpen = ref(false);
const isSubscriptionsInvalid = ref(false);
let showModalLeaveOrg = ref(false);
let updateModal = ref(false);
const isShow = ref(false);
const searchKey = ref("");
const visible = ref(false);
const switcherRef = ref<HTMLDivElement | null>(null);
let orgSelected = "";
const styleClass = {
  background: "rgb(0, 0, 0, 0)",
  "border-radius": "6px",
};
const searchValue: Ref<string> = ref("");

const orgPlanDetails = computed(() => store.getters["Org/getPlanDetails"]);

watch(
  () => orgPlanDetails.value,
  () => {
    if (!orgPlanDetails.value || !orgPlanDetails.value.planId) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  },
);

watch(
  () => props.userData,
  async (value) => {
    if (value && value.userId) {
      await store.dispatch("Org/fetchOrgList", value);
    }
  },
);

const currentOrg = computed(() => store.getters["Org/getCurrentOrg"]);
const orgList = computed(() => {
  if (isSubscriptionsInvalid.value) {
    return store.state.Org.orgsList.filter(
      (org) => org.id === currentOrg.value.id || org.isHome,
    );
  }
  return store.state.Org.orgsList;
});
const orgListData = ref<any[]>([]);
const originOrgsList = computed(() => store.state.Org.originOrgsList);
const modal = ref(null) as Ref<ModalTypes | null>;
const modalType = ref<keyof typeof requestAccessDetailModalType>(
  requestAccessDetailModalType.createRequest,
);
const orgDataEdit = ref<any>();
let selectedOrgModal = ref(-1);
let typeOfAction = "";
const typeOfActionData = {
  switchOrg: "switchOrg",
  create: "create",
  manageOrg: "manageOrg",
};
const setModal = (val) => {
  modal.value = val;
  history.state.modal = val;
};

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (oldValue.id && newValue.id && newValue.id !== oldValue.id) {
      store.dispatch("Org/fetchOrgRoles");
    }
  },
);

watch(
  () => orgList.value,
  (value) => {
    orgListData.value = value;
  },
  { immediate: true },
);

const isDirtySetup = computed(() => {
  return store.getters["SetupWizard/isDirty"];
});

// Define your component methods
const closeModal = () => {
  isShow.value = false;
  closeMenu();
};


const showModal = (ischeckSetup = true) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.manageOrg;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
      setTimeout(() => {
        store.dispatch("Overlay/showOverlay");
      }, 100);
    }
  }
  if (!ischeckSetup) {
    setTimeout(() => {
      store.dispatch("Overlay/showOverlay");
    }, 100);
  }
  if (currentOrg.value.id !== 0) {
    isMenuOpen.value = false;
    isShow.value = true;
  }
};

const closeMenu = () => {
  isMenuOpen.value = false;
  EventEmitter.emit("setZIndexIConNavBar", false);
};

const openLeaveModal = (orgId) => {
  updateModal.value = false;
  selectedOrgModal.value = orgId;
  showModalLeaveOrg.value = true;
};

const emitStatus = () => {
  if (!props.statusSetupModal) {
    if (isMenuOpen.value) store.dispatch("Overlay/showOverlay");
    else store.dispatch("Overlay/hideOverlay");
  } else {
    if (isMenuOpen.value) visible.value = true;
    else visible.value = false;
  }
};

const onLeaveOrg = async () => {
  try {
    await leaveOrg(selectedOrgModal.value);
    store.dispatch("Org/fetchOrgList");
    updateModal.value = true;
    showModalLeaveOrg.value = false;
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.leaveOrg);
    }
  }
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  if (isMenuOpen.value) {
    EventEmitter.emit("setZIndexIConNavBar", true);
    EventEmitter.emit(EmitterEvents.CLOSE_ALL_POPOVERS, true);
  } else {
    EventEmitter.emit("setZIndexIConNavBar", false);
  }
};

const handleSelectOrg = async (org: any, ischeckSetup = true) => {
  searchValue.value = "";
  orgListData.value = orgList.value;
  const isHomeOrg = org?.isHome;
  store.commit("Recommend/REMOVE_SELECTED_ASSESSMENT_QUESTIONS");
  if (org.id === currentOrg.value.id) {
    isMenuOpen.value = false;
    return;
  }
  store.commit("Org/SET_STATUS_CALL_API_CHECK_PARENT", false);
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.switchOrg;
      orgSelected = org;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    }
  }
  isOrgSwitchLoading.value = true;
  isMenuOpen.value = false;
  const res = await store.dispatch("Org/switchOrg", {
    orgId: org.id,
    isHomeOrg,
  });
  if (res) {
    isOrgSwitchLoading.value = false;
    store.dispatch("Recommend/fetchChecklistData");
    store.dispatch("Scanning/fetchScanHistoryWebServices");
    store.dispatch("Scanning/fetchScanHistoryDomains");
  } else {
    store.commit("Org/SET_CURRENT_PARENT_ORG", {});
    store.commit("Org/SET_ORGS_LIST", []);
    for (const org of originOrgsList.value) {
      const paramOrgId = org.id == currentOrg.value.orgId ? null : org.id;
      if (org?.profileData?.avatarImageId) {
        const res = await getProfileImage(
          org.profileData.avatarImageId,
          paramOrgId,
        );
        const imageDetails = res.data.data;
        const imgBlob = await getImageData(imageDetails);
        org.img = URL.createObjectURL(imgBlob);
      }
    }
    const parent = JSON.parse(
      localStorage.getItem(localStorageKey.currentOrgData) || "{}",
    );
    if (parent?.idParentOrg) {
      try {
        const currentParentOrg = originOrgsList.value.find(
          (org) => org.id === parent.idParentOrg,
        );
        const listOrg = originOrgsList.value.filter(
          (org) => org.id !== parent.idParentOrg,
        );
        const profileParent = await getOrgIdProfile(currentParentOrg.id);
        if (profileParent.status == 200) {
          const data = profileParent.data.data;
          if (
            data?.logosm?.logoSmImageFileId ||
            data?.logolg?.logoLgImageFileId ||
            data?.avatar?.avatarImageFileId
          ) {
            const res = await getProfileImage(
              data?.logosm?.logoSmImageFileId ||
                data?.logolg?.logoLgImageFileId ||
                data?.avatar?.avatarImageFileId,
              data?.orgId,
            );
            const imageDetails = res.data.data;
            const imgBlob = await getImageData(imageDetails);
            currentParentOrg.imgLogo = URL.createObjectURL(imgBlob);
          }
        }
        store.commit("Org/SET_CURRENT_PARENT_ORG", currentParentOrg);
        store.commit("Org/SET_ORGS_LIST", listOrg);
      } catch (error) {
        showErrorAPI(error, Org.getOrgIdProfile);
      }
    } else {
      store.commit("Org/SET_ORGS_LIST", originOrgsList.value);
      store.commit("Org/SET_CURRENT_PARENT_ORG", {});
    }
    store.commit("Org/SET_STATUS_CALL_API_CHECK_PARENT", true);
    isOrgSwitchLoading.value = false;
  }

  EventEmitter.emit(EmitterEvents.EVENT_KEYBOARD_ESC);
};

const route = useRoute();
const router = useRouter();

const openCreateOrgModal = (ischeckSetup = true) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.create;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    }
  }
  EventEmitter.emit(
    EmitterEvents.SET_PRIMARY_MENU_INDEX,
    INDEX_PRIMARY_PAGE.setting,
  );
  router.push({
    name: "ManageAccess",
    query: { isOpenCreateModal: localStorageBoolean.true },
  });
  toggleMenu();
  if (route.name === "ManageAccess") {
    location.reload();
  }
};

const onClickOutside = (event: Event) => {
  const cond = document.getElementById("pricing-table-container");
  const searchBiox = document.getElementById("search-box-org");
  if (cond || searchBiox) {
    return;
  }
  if (!switcherRef.value?.contains(event.target as HTMLDivElement)) {
    isMenuOpen.value = false;
  }
};

// Watch for changes in isMenuOpen

watch(isMenuOpen, emitStatus);
onMounted(() => {
  EventEmitter.on("saveAndExitDone", (isCloseWiard) => {
    if (isCloseWiard) {
      isMenuOpen.value = false;
      return;
    }
    EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    switch (typeOfAction) {
      case typeOfActionData.switchOrg:
        handleSelectOrg(orgSelected, false);
        break;
      case typeOfActionData.create:
        openCreateOrgModal(false);
        break;
      case typeOfActionData.manageOrg:
        showModal(false);
        break;
      default:
        break;
    }
  });
  EventEmitter.on("active-org-dropDown-close-dropdown", (value) => {
    isMenuOpen.value = value ? true : false;
  });
  window.addEventListener("click", onClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", onClickOutside);
});

onUnmounted(() => {
  EventEmitter.off("saveAndExitDone");
  EventEmitter.off("active-org-dropDown-close-dropdown");
});

onMounted(() => {
  EventEmitter.on(
    EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
    (value) => {
      if (value) {
        searchKey.value = typeof value === "string" ? value : "";
        showModal();
      } else {
        closeModal();
      }
    },
  );
  EventEmitter.on(EmitterEvents.PAGE_LOADING_COMPLETED, (value) => {
    isOrgSwitchLoading.value = value ? true : false;
  });
});

const actionsUpdateFilter = debounce((value: string) => {
  searchValue.value = value;
  handleFilter();
}, 300);

const handleFilter = () => {
  if (!searchValue.value) {
    orgListData.value = orgList.value;
    return;
  }
  // filter orglist follow item.name or item.nameLegal
  orgListData.value = orgList.value.filter((item) => {
    const name = item.name?.toLowerCase() || "";
    const nameLegal = item.nameLegal?.toLowerCase() || "";
    const search = searchValue.value.toLowerCase();
    return name.includes(search) || nameLegal.includes(search);
  });
};

const handleEnterSearch = () => {
  if (searchValue.value) {
    if (orgListData.value.length !== 1) return;
    handleSelectOrg(orgListData.value[0]);
    searchValue.value = "";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_KeepAlive, null, [
      _createElementVNode("div", {
        id: "menu-btn-active-drop-down",
        ref_key: "switcherRef",
        ref: switcherRef,
        class: "dropdown"
      }, [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "switcher-backdrop",
              class: "tw-fixed tw-top-[56px] tw-w-full tw-h-screen tw-z-[1] tw-left-0 tw-bg-[rgba(0,0,0,0.5)]",
              style: {"z-index":"3000"},
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isMenuOpen.value = false), ["stop"]))
            }))
          : _createCommentVNode("", true),
        (!isOrgSwitchLoading.value && currentOrg.value?.id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "dropdown-btn",
              "data-cy": "switch-org-dropdown-btn",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => toggleMenu(), ["stop"])),
              onKeyup: _withKeys(closeMenu, ["esc"])
            }, [
              (!isOrgSwitchLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    (currentParentOrg.value?.id)
                      ? (_openBlock(), _createBlock(GlobalAvatar, {
                          key: 0,
                          name: currentParentOrg.value?.name,
                          src: currentParentOrg.value?.img,
                          "class-name": 'active-org-icon'
                        }, null, 8, ["name", "src"]))
                      : _createCommentVNode("", true),
                    (currentParentOrg.value?.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                      : _createCommentVNode("", true),
                    _createVNode(GlobalAvatar, {
                      name: currentOrg.value?.name,
                      src: currentOrg.value?.img,
                      "class-name": 'active-org-icon'
                    }, null, 8, ["name", "src"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(currentOrg.value?.name), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                (isMenuOpen.value)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6))
              ])
            ], 40, _hoisted_1))
          : _createCommentVNode("", true),
        (isOrgSwitchLoading.value || !currentOrg.value?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_unref(LottieAnimation), {
                  ref: "anim",
                  "animation-data": _unref(ProgressAnimation),
                  "auto-play": true,
                  loop: true
                }, null, 8, ["animation-data"])
              ])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(`dropdown__menu tw-pb-[15px] ${
          currentParentOrg.value?.id ? '' : 'tw-pt-[20px]'
        }`)
        }, [
          (currentParentOrg.value?.id)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tw-flex org-text tw-px-[15px] tw-py-[15px] tw-justify-between parent tw-cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelectOrg(currentParentOrg.value)))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(GlobalAvatar, {
                    name: currentParentOrg.value?.name,
                    src: currentParentOrg.value.img,
                    "class-name": 'org-icon'
                  }, null, 8, ["name", "src"]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(currentParentOrg.value?.name), 1)
                ]),
                _createElementVNode("div", null, [
                  (currentParentOrg.value?.isHome)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(`dropdown__menu__title ${
            currentParentOrg.value?.id
              ? 'dropdown__menu__title__parent'
              : 'dropdown__menu__title__no__parent'
          }`)
          }, _toDisplayString(_unref(getComponentUiText)("app-org-switcher-title-1")), 3),
          (orgList.value.length > 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(BaseSearchbox, {
                  class: _normalizeClass([
              'tw-relative tw-h-[36px] tw-rounded-[6px] tw-mb-2 tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF] tw-px-[15px] search-box',
            ]),
                  "input-style": "tw-bg-[#FFFFFF] !tw-text-[12px] tw-mt-[1px]",
                  "icon-search-style": 'tw-scale-[0.867]',
                  "icon-close-style": 'tw-scale-[0.8]',
                  "model-value": searchValue.value,
                  placeholder: _unref(getComponentUiText)('app-header-search-prompt-1'),
                  "onUpdate:modelValue": _unref(actionsUpdateFilter),
                  "onOn:focus": () => {},
                  "onOn:blur": () => {},
                  onKeyup: _withKeys(handleEnterSearch, ["enter"])
                }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue", "onKeyup"])
              ]))
            : _createCommentVNode("", true),
          (orgList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
                  return _createElementVNode("div", {
                    key: index,
                    style: {"border-bottom":"1px solid #eff0f1"},
                    class: _normalizeClass(`custom-global-skeleton tw-w-full tw-h-[50px] ${
              index !== 2 ? 'list__skeleton' : 'list__skeleton__last'
            }`)
                  }, null, 2)
                }), 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgListData.value, (org) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: org.id,
                    style: _normalizeStyle(`${
              currentParentOrg.value?.id ? '' : 'border-top: 1px solid #eff0f1'
            }`),
                    class: "dropdown__menu__item dropdown__menu__item__org",
                    onClick: () => handleSelectOrg(org)
                  }, [
                    _createElementVNode("span", _hoisted_16, [
                      (org.isHome && org.img)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: org.img,
                            alt: "profilePicture",
                            class: "tw-w-[20px] tw-h-[20px] tw-rounded-[50%] profilePicture"
                          }, null, 8, _hoisted_17))
                        : (_openBlock(), _createBlock(GlobalAvatar, {
                            key: 1,
                            name: org?.name,
                            src: org.img,
                            "class-name": 'org-icon'
                          }, null, 8, ["name", "src"])),
                      _createElementVNode("span", {
                        "data-cy": `${
                  org.id === currentOrg.value.id
                    ? 'current-org-true'
                    : 'current-org-false'
                }`,
                        class: "org-text org-text-name !tw-truncate tw-max-w-[120px]"
                      }, _toDisplayString(org?.name), 9, _hoisted_18),
                      _createElementVNode("span", {
                        class: _normalizeClass(`org-text org-text-legal !tw-truncate ${
                  org.id !== currentOrg.value.id
                    ? 'tw-max-w-[220px]'
                    : 'tw-max-w-[120px]'
                }`)
                      }, _toDisplayString(org?.nameLegal), 3),
                      (org.isHome)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_20, [
                      (org.id === currentOrg.value.id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_unref(getComponentUiText)("app-org-switcher-active-org-1")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 12, _hoisted_15))
                }), 128))
              ])),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", null, [
              _createElementVNode("button", {
                class: _normalizeClass(`tw-bg-white tw-border-none tw-w-full ${
                isSubscriptionsInvalid.value || !orgPlanDetails.value?.planId
                  ? 'tw-pointer-events-none'
                  : ''
              }`),
                onClick: _cache[3] || (_cache[3] = () => showModal())
              }, [
                _createElementVNode("span", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-manage-orgs-heading-1")), 1),
                  _hoisted_24
                ])
              ], 2)
            ]),
            _createElementVNode("span", null, [
              _createElementVNode("button", {
                class: _normalizeClass(`tw-bg-white tw-border-none tw-w-full ${
                isSubscriptionsInvalid.value || !orgPlanDetails.value?.planId
                  ? 'tw-pointer-events-none'
                  : ''
              }`),
                onClick: _cache[4] || (_cache[4] = () => openCreateOrgModal())
              }, [
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-org-switcher-create-org-1")), 1),
                  _hoisted_26
                ])
              ], 2)
            ])
          ])
        ], 2), [
          [_vShow, isMenuOpen.value]
        ]),
        _createVNode(Modal, {
          visible: isShow.value,
          "max-width": 70,
          "close-on-esc": !(modal.value === _unref(ModalTypes).CreateOrg),
          "style-modal": `${
          modal.value === _unref(ModalTypes).CreateOrg ? '!tw-max-h-[680px]' : ''
        }`,
          onClose: closeModal
        }, {
          default: _withCtx(() => [
            _createVNode(ManageOrgDropDown, {
              "model-value": isShow.value,
              "update-modal": _unref(updateModal),
              "search-key": searchKey.value,
              onCloseModal: closeModal,
              onLeaveOrg: openLeaveModal,
              onCreateOrg: _cache[5] || (_cache[5] = 
            ({ data, mode }) => {
              modal.value = _unref(ModalTypes).CreateOrg;
              orgDataEdit.value = data;
              modalType.value = mode;
            }
          )
            }, null, 8, ["model-value", "update-modal", "search-key"])
          ]),
          _: 1
        }, 8, ["visible", "close-on-esc", "style-modal"]),
        _createVNode(ManageUserModal, {
          show: _unref(showModalLeaveOrg),
          header: false,
          "red-btn": true,
          "contain-title": "app-manage-orgs-leave-org-header-modal-1",
          "contain-sub-title": "app-manage-orgs-leave-org-modal-leave-action-helper-1",
          "action-title": "app-manage-orgs-leave-org-header-modal-1",
          "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_isRef(showModalLeaveOrg) //@ts-ignore
 ? showModalLeaveOrg.value = $event : showModalLeaveOrg = $event)),
          "onUpdate:actionHandle": onLeaveOrg
        }, null, 8, ["show"]),
        _withDirectives(_createElementVNode("div", _mergeProps({
          role: "dialog",
          tabindex: "-2",
          "aria-modal": "true",
          "aria-label": "Modal window"
        }, _ctx.$attrs, {
          class: "v-modal",
          style: styleClass,
          onClick: _cache[7] || (_cache[7] = () => (modal.value = null))
        }), null, 16), [
          [_vShow, modal.value === _unref(ModalTypes).CreateOrg]
        ])
      ], 512)
    ], 1024)),
    (modal.value === _unref(ModalTypes).CreateOrg)
      ? (_openBlock(), _createBlock(CreateOrgModal, {
          key: 0,
          show: modal.value === _unref(ModalTypes).CreateOrg,
          "org-data": orgDataEdit.value,
          type: modalType.value,
          "hide-overlay": false,
          class: "tw-z-[2000]",
          "onUpdate:show": setModal
        }, null, 8, ["show", "org-data", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})